import TextField from "@mui/material/TextField";
import { Button, Grid } from "@mui/material";
import logo247UpTime from "../../assets/247uptime-logo.svg";
import Typography from "@mui/material/Typography";
import { connect } from "react-redux";
import { useRef, useState } from "react";
import BeatLoader from "react-spinners/BeatLoader";
import { makeStyles } from "tss-react/mui";
import { Theme247 } from "../../styles/Theme247";
import Box from "@mui/material/Box";
import { setpassword, submitSignupUser } from "../../actions/user";
import OutlinedInput from "@mui/material/OutlinedInput";
import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import { isValidEmail } from "../../utils/helpers";
import ReCaptcha from "../../components/ReCaptcha";
import { ReactComponent as SignUpMessage } from "../../assets/SignUpMessage.svg";

export default connect(
  ({
    // to use redux states here
    i18n,
    isLoading,
  }) => ({
    i18n,
    isLoading,
  }),
  {
    submitSignupUser,
    // redux functions
  }
)((props) => {
  let i18n = props.i18n;
  const isLoading = props.isLoading;
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [businessEmail, setBusinessEmail] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [companyNameError, setCompanyNameError] = useState("");
  const [emailError, setEmailError] = useState("");

  const [captchValue, setCaptchValue] = useState("");

  const [formSubmitted, setFormSubmitted] = useState(false);

  const navigate = useNavigate();

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  let firstNameRef = useRef();

  const submitForm = () => {
    setFirstNameError(false);
    setLastNameError(false);
    setCompanyNameError(false);
    setEmailError(false);

    let hasError = false;

    //Check if first name is empty
    if (firstName === "") {
      setFirstNameError(true);
      firstNameRef.current.focus();
      hasError = true;
    }
    //Check if last name is empty
    if (lastName === "") {
      setLastNameError(true);
      hasError = true;
    }
    if (companyName === "") {
      setCompanyNameError(true);
      hasError = true;
    }
    // Email validation
    if (businessEmail === "") {
      setEmailError(true);
      hasError = true; // Mark as having an error
    } else if (!businessEmail.includes("@")) {
      setEmailError(true);
      hasError = true; // Mark as having an error
    } else {
      let isvalidemail = true;
      if (!isvalidemail) {
        setEmailError(true);
        hasError = true; // Mark as having an error
      }
    }

    // Prevent form submission if there's any error
    if (hasError) {
      return;
    }

    // Proceed if the email is valid
    props.submitSignupUser({
      givenname: firstName,
      surname: lastName,
      companyName: companyName,
      email: businessEmail,
    });

    setFormSubmitted(true);
    setCaptchValue("")
    // navigate("/login");
  };

  const textWithIcon = (text) => {
    return (
      <div className="textWithIcon">
        <div className="icon">
          <img src="../images/signupTick.svg" />
        </div>
        <div className="text">{text}</div>
      </div>
    );
  };

  const getCaptchValue = (value) =>{
    setCaptchValue(value)
  }

  return (
    <>
      <div className="signup">
        {/* <img
          src="../images/application-scope-heading.png"
          style={{width: "95%", height: "100%"}}
          alt="247UpTime Logo"
        /> */}
        <div className="signupScopeHeaderFrame btl4 bbl4">
          <div className="wrapper">
            <div className="title">247UpTime 30 Tage kostenfrei testen</div>
            {textWithIcon("Alle Funktionen und Bereiche testen")}
            {textWithIcon("Sofortige Bereitstellung")}
            {textWithIcon("Keine Kreditkarte notwendig")}
          </div>
        </div>

        <form className="signup-form btr4 bbr4" action="/action_page.php" style={{ padding: formSubmitted ? "20px 45px 0px 45px" : "45px"}}>
          <div className="header">
            <img
              src={logo247UpTime}
              style={{ width: "auto", height: "48px" }}
              alt="247UpTime Logo"
            />
            <div style={{ width: "326px", display : formSubmitted ? "block" : "none" }}>
              <Typography className="title" variant="h1">
                {formSubmitted
                  ? "" + i18n.signUpHeading2
                  : "" + i18n.signUpHeading}
              </Typography>

              <div style={{ marginTop : "85px"}}>
                <SignUpMessage />
              </div>

              <Typography style={{ margin: "28px 0px" }}>
                Bitte prüfen Sie Ihr Postfach: Eine E-Mail mit Ihrem
                Aktivierungslink wurde an <b>{businessEmail}</b> gesendet.
              </Typography>

              <Typography style={{ margin: "10px 0px" }}>
                Klicken Sie auf den Link, um Ihre Registrierung abzuschließen.
              </Typography>

              <Button
                //These are properties
                fullWidth
                variant="outlined"
                color="primary"
                size="large"
                style={{ margin: "10px 0px 100px 0px" }}
                onClick={()=>{ setFormSubmitted(false)}}
              >
                {"E-Mail-Adresse ändern"}
              </Button>
            </div>
          </div>

          {formSubmitted ? (
            ""
          ) : (
            <>
              <div className="personalInfo">
                <TextField
                  required
                  id="outlined-basic"
                  // className={(Theme247.inputFieldOpaqueWhite)}
                  value={firstName}
                  placeholder={i18n.first_name}
                  variant="outlined"
                  onChange={(e) => {
                    setFirstName(e.target.value);
                  }}
                  error={firstNameError}
                  inputRef={firstNameRef}
                  helperText={firstNameError ? i18n.required_field : ""}
                />

                <TextField
                  required
                  id="outlined-basic"
                  value={lastName}
                  placeholder={i18n.last_name}
                  variant="outlined"
                  onChange={(e) => {
                    setLastName(e.target.value);
                  }}
                  error={lastNameError}
                  helperText={lastNameError ? i18n.required_field : ""}
                />
              </div>
              <TextField
                required
                fullWidth
                id="outlined-basic"
                // className={(Theme247.inputFieldOpaqueWhite)}
                value={companyName}
                placeholder={i18n.companyName}
                variant="outlined"
                onChange={(e) => {
                  setCompanyName(e.target.value);
                }}
                error={companyNameError}
                helperText={companyNameError ? i18n.required_field : ""}
              />
              <TextField
                className="email"
                fullWidth
                type="email"
                id="outlined-basic"
                value={businessEmail}
                variant="outlined"
                placeholder={i18n.businessEmail}
                onChange={(e) => {
                  setBusinessEmail(e.target.value);
                }}
                error={emailError}
                helperText={emailError ? i18n.required_field : ""}
                onKeyDown={(ev) => {
                  if (ev.key === "Enter") {
                    // Do code here
                    ev.preventDefault();
                    submitForm();
                  }
                }}
              />
              {/* <TextField
            fullWidth
            type={showPassword ? "text" : "password"}
            placeholder={i18n.password}
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleTogglePasswordVisibility}>
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          /> */}

              <ReCaptcha getCaptchValue={getCaptchValue}/>
              <Button
                className="createAccount"
                fullWidth
                variant="contained"
                color="primary"
                size="large"
                disabled={isLoading || captchValue === ""}
                onClick={() => {
                  submitForm();
                }}
              >
                {!isLoading && i18n.createAccount}
              </Button>
              <p className="separator">
                <img className="separator-line" src="../images/line.png" />
                oder
                <img className="separator-line" src="../images/line.png" />
              </p>
              <Link to="/login">
                <Button
                  //These are properties
                  fullWidth
                  variant="outlined"
                  color="primary"
                  size="large"
                >
                  {!isLoading && i18n.toLogin}
                </Button>
              </Link>
            </>
          )}
        </form>
      </div>
    </>
  );
});
